import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { onMount } from "svelte";

export const useInAppDetector = (
  setInApp: (inApp: boolean) => void,
  setStickyTitle: (isSticky: boolean) => void,
): void => {
  onMount(async () => {
    /*                                    */
    /*                                                                                                       */
    await eventQBus.once("apps.global.assets-loaded");

    setInApp(window.o_apps.runningInApp());

    /*                                              */
    setStickyTitle(
      !!document.querySelector(
        'meta[name="apps-focused-layout-top-bar-visibility"][content="hidden"]',
      ),
    );
  });
};
